// extracted by mini-css-extract-plugin
module.exports = {"diagramTemplateDownload":"RecipeDownloadTemplate_diagramTemplateDownload__OHS2x","diagramTitle":"RecipeDownloadTemplate_diagramTitle__HtnGu"};